import type { ComponentProps } from 'react';
import Toggle from '@/components/ui/Toggle';
import Tooltip from '@/components/ui/Tooltip';

export default function LocationToggle({ disabledReason, ...props }: ComponentProps<typeof Toggle> & { disabledReason?: string }) {
  const toggle = <Toggle {...props} />;
  return props.disabled && disabledReason
    ? <Tooltip content={disabledReason} className="shrink-0">{toggle}</Tooltip>
    : toggle;
}
